import type { CourseResponseSectionsItemLecturesItem } from './courseResponseSectionsItemLecturesItem';

export type CourseResponseSectionsItem = {
  id: number;
  lectures: CourseResponseSectionsItemLecturesItem[];
  title: string;
};
